// language=GraphQL
import { gql } from '@apollo/client'
import { USER_NODE } from '../fragments/user.fragment'

// @todo go through all getuser instances and define appropriate fragment (fetching all data right now)
export const GET_USER = gql`
  query GetUser {
    user {
      ...UserNode
    }
  }
  ${USER_NODE}
`

export const EMAIL_VALIDATOR = gql`
  query GetEmailValidator($input: EmailValidatorInput!) {
    emailValidator(input: $input) {
      isValid
      message
    }
  }
`
